import { mixins, styled } from '@bob/library'

export const SeeMore = styled.button`
  color: ${mixins.colors.corporateBlue};
  cursor: pointer;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  width: fit-content;
`

export const MainMarketInfo = styled.div`
  ${mixins.typography.paragraphSmall};
  ${mixins.margin.top(10)};
  ${mixins.margin.bottom(10)};
`

export const CloseButton = styled.button`
  color: ${mixins.colors.corporateBlue};
  cursor: pointer;
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  right: 25px;
`
